// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"141":"component---src-pages-markdown-remark-frontmatter-slug-tsx","230":"component---src-pages-index-jsx"}[chunkId] + "-" + {"141":"cec346246aef9d35627e","230":"d6fc44b82268d623d6cd"}[chunkId] + ".js";
};